export default __webpack_public_path__ + "static/media/tillRegistation.88522ae4.png";